<template>
  <vs-popup
    :title="'Add setup for ' + activeVenueDetails.name"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="add-setup-popup"
  >
    <div>
      <h6 class="mt-0">Name of the setup</h6>
      <p class="mb-1"><small>Give it a name. Example: 'Regular week'</small></p>
      <vs-input class="inputx" placeholder="Setup name" v-model="setupName" />

      <h6 class="mt-6">Copy from existing setup?</h6>
      <p class="mb-1" style="max-width: 48rem; line-height: 1.4">
        <small>You can choose a setup to base off you new setup</small>
      </p>
      <div class="flex">
        <vs-select v-if="activeVenueSetups" v-model="baseSetup" placeholder="Not copying">
          <vs-select-item
            :key="index"
            :value="item"
            :text="'Copy from: ' + item.name"
            v-for="(item, index) in activeVenueSetups"
          />
        </vs-select>
        <vs-button
          color="primary"
          type="flat"
          class="py-1 px-2"
          v-show="baseSetup != null"
          @click="baseSetup = null"
        >
          <feather-icon
            icon="XIcon"
            svgClasses="h-5 w-5"
            size="small"
          ></feather-icon>
        </vs-button>
      </div>
    </div>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        color="primary"
        :disabled="!validForm"
        @click="handleSaveSetupClick"
        >Save Setup</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";

export default {
  components: {},
  data() {
    const that = this;
    return {
      setupName: "",
      baseSetup: null,
      setups: [],
      showThisPopup: false,
      callback: null,
    };
  },
  computed: {
    ...mapGetters({
      activeVenueDetails: "marcom/activeVenue",
      activeVenueSetups: "marcom/activeVenueSetups",
    }),
    validForm() {
      return this.setupName !== "";
    },
  },
  methods: {
    show() {
      this.showThisPopup = true;
    },
    async handleSaveSetupClick() {
      try {
        this.$vs.loading();

        if (!this.baseSetup) {
          //Add
          const setupCommand = {
            venueDetailsId: this.activeVenueDetails.venueDetailsId,
            setupName: this.setupName,
          };

          await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.AddSetup,
            setupCommand
          );
        } else {
          //Copy
          const setupCommand = {
            venueSetupId: this.baseSetup.venueSetupId,
            setupName: this.setupName,
          };

          await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.CopyVenueSetup,
            setupCommand
          );
        }

        this.$vs.notify({
          color: "success",
          title: "Setup added",
          text: "Your setup was added",
        });

        this.handlePopupClose();

      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Setup added error",
          text: "Oops, something went wrong: " + err.title,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    handlePopupClose() {
      this.setupName = "";
      this.baseSetup = null;
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-setup-popup::v-deep .vs-popup {
  width: 1080px;
}
</style>
